import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthProvider';
import Layout from './components/layout/Layout';
import Login from './components/Login';
import SignUp from './components/SignUp';
import Calculations from './components/Calculations/index.js';
import UpdatePassword from './components/UpdatePassword';
import ResetPassword from './components/ResetPassword';
import Profile from './components/Profile';
import AnalyticsDashboard from './components/AnalyticsDashboard';
import Landing from './components/Landing';
import AuthCallback from './components/AuthCallback';
import AboutContact from './components/AboutContact/AboutContact';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';
import TermsOfService from './components/TermsOfService';
import PricingPage from './components/PricingPage';
import CheckoutSuccess from './components/CheckoutSuccess';
import CheckoutCancel from './components/CheckoutCancel';
import Footer from './components/Footer';
import './styles/global.css';
import './styles/App.css';
import { Analytics } from '@vercel/analytics/react';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
};

// AppRoutes component to handle route rendering
const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes that don't require authentication */}
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/update-password" element={
        <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
          <UpdatePassword />
        </div>
      } />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/forgot-password" element={<ResetPassword />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/login" element={<Login />} />
      <Route path="/about-contact" element={<AboutContact />} />
      <Route path="/terms" element={<TermsOfUse />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/pricing" element={<PricingPage />} />
      
      {/* Protected routes */}
      <Route
        path="/calculations"
        element={
          <ProtectedRoute>
            <Calculations />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/analytics"
        element={
          <ProtectedRoute>
            <AnalyticsDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/checkout/success"
        element={
          <ProtectedRoute>
            <CheckoutSuccess />
          </ProtectedRoute>
        }
      />
      <Route
        path="/checkout/cancel"
        element={
          <ProtectedRoute>
            <CheckoutCancel />
          </ProtectedRoute>
        }
      />

      {/* Home route */}
      <Route path="/" element={<Landing />} />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          minHeight: '100vh'
        }}>
          <Layout>
            <AppRoutes />
          </Layout>
          <Footer />
          <Analytics />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;